import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Modal, Row} from 'antd';
import {InfoCircleTwoTone} from '@ant-design/icons';
import styled from 'styled-components';
import StoreActions from "bukku/redux/Store/actions";
import {StoreButton} from "../Button";

const {
    toggleCheckoutConfirmationModal,
    placeOrder,
    clearPaymentData,
} = StoreActions;

const Styled = styled.div`
  .ant-modal-content {
    border-radius: 10px;

    .ant-modal-close-x {
      color: rgba(255, 255, 255, 80%);
    }
  }

  .ant-modal-body {
    background-color: #f0fffe;
    border-radius: 9px;

    p {
      margin-bottom: 8px;
    }

    .ant-modal-confirm-btns {
      margin-top: 24px;
    }
  }
`;

class CheckoutConfirmationModal extends Component {
    isLoading = () => {
        const { placeOrderState, pendingPayment } = this.props;
        return placeOrderState === 'request' || pendingPayment;
    };

    onOk = () => {
        const { placeOrder } = this.props;
        if (!this.isLoading())
            placeOrder();
    };

    onCancel = () => {
        const { toggleCheckoutConfirmationModal, placeOrderState, clearPaymentData } = this.props;
        if (placeOrderState !== 'request') {
            toggleCheckoutConfirmationModal(false);
            clearPaymentData();
        }
    };

    render() {
        const { visible, store } = this.props;

        return (
            <Styled id="bukku-store-checkout-confirmation-modal">
                <Modal
                    open={visible}
                    destroyOnClose
                    zIndex={2000}
                    footer={null}
                    width={416}
                    onOk={this.onOk}
                    onCancel={this.onCancel}
                    getContainer={() => document.getElementById('bukku-store-checkout-confirmation-modal')}
                >
                    <div className="ant-modal-confirm-body-wrapper">
                        <div className="ant-modal-confirm-body">
                            <InfoCircleTwoTone twoToneColor="#13c2c2" />
                            <span className="ant-modal-confirm-title">Confirm Order</span>
                            <div className="ant-modal-confirm-content">
                                <div>
                                    <p>Do you want to proceed with the order?</p>
                                    { store.hasPaymentGateway ?
                                        <p>You will be redirected to make payment for the order.</p> : null }
                                    <p>
                                        Please note that you will need to arrange the delivery /
                                        &nbsp;pick up of the order with the merchant.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="ant-modal-confirm-btns">
                            <Row gutter={[8, 0]} wrap={false} align="middle" justify="end">
                                <Col>
                                    <StoreButton
                                        type="primary"
                                        onClick={this.onOk}
                                        loading={this.isLoading()}
                                    >
                                        Place Order

                                    </StoreButton>
                                </Col>
                                <Col>
                                    <StoreButton onClick={this.onCancel}>Cancel</StoreButton>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal>
            </Styled>
        );
    }
}
export default connect(state => ({
    visible: state.Store.checkoutConfirmationModalVisible,
    placeOrderState: state.Store.placeOrderState,
    pendingPayment: state.Store.pendingPayment,
    store: state.Store.store,
}), {
    toggleCheckoutConfirmationModal,
    placeOrder,
    clearPaymentData,
})(CheckoutConfirmationModal);
